import CryptoJS from 'crypto-js';

// Log environment variables for debugging
console.log('Crypt.js - process.env:', process.env);
console.log('Crypt.js - REACT_APP_AES_SECRET_KEY:', process.env.REACT_APP_AES_SECRET_KEY);
console.log('Crypt.js - REACT_APP_AES_IV:', process.env.REACT_APP_AES_IV);

// Retrieve environment variables with fallback values
const AES_SECRET_KEY = process.env.REACT_APP_AES_SECRET_KEY ;
const AES_IV = process.env.REACT_APP_AES_IV ;

// Warn if environment variables are missing
if (!process.env.REACT_APP_AES_SECRET_KEY) {
  console.warn('REACT_APP_AES_SECRET_KEY is not defined, using fallback key. Check your .env file.');
}
if (!process.env.REACT_APP_AES_IV) {
  console.warn('REACT_APP_AES_IV is not defined, using fallback IV. Check your .env file.');
}

// Encrypt function
export const encrypt = (data) => {
  if (!data) {
    console.error('Encryption error: No data provided');
    return '';
  }
  try {
    const encrypted = CryptoJS.AES.encrypt(
      data,
      CryptoJS.enc.Utf8.parse(AES_SECRET_KEY),
      {
        iv: CryptoJS.enc.Utf8.parse(AES_IV),
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      }
    );
    const encryptedText = encrypted.toString();
    console.debug('Encrypted:', { input: data, output: encryptedText });
    return encryptedText;
  } catch (error) {
    console.error('Encryption error:', error.message);
    return '';
  }
};

// Decrypt function
export const decrypt = (ciphertext) => {
  if (!ciphertext) {
    console.error('Decryption error: No ciphertext provided');
    return '';
  }
  try {
    const bytes = CryptoJS.AES.decrypt(
      ciphertext,
      CryptoJS.enc.Utf8.parse(AES_SECRET_KEY),
      {
        iv: CryptoJS.enc.Utf8.parse(AES_IV),
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      }
    );
    const plaintext = bytes.toString(CryptoJS.enc.Utf8);
    if (!plaintext) {
      console.error('Decryption error: Empty or invalid plaintext');
      return '';
    }
    console.debug('Decrypted:', { input: ciphertext, output: plaintext });
    return plaintext;
  } catch (error) {
    console.error('Decryption error:', error.message);
    return '';
  }
};